import { inject, Injectable } from '@angular/core';
import { ServicesService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class ResultEndpointService {
  readonly #service = inject(ServicesService);

  groupResult(
    groupCode: string,
    arrangementCode: string,
    contentIdentifier: string,
  ) {
    return this.#service.thor(
      `group/${groupCode}/score/${arrangementCode}/${contentIdentifier}`,
    );
  }

  bulkDeleteGroupResult(groupCode: string) {
    return this.#service.thor(`group/${groupCode}/delete-bulk`);
  }
}
